import { AxiosResponse } from 'axios';
import httpRequest, { API_ROUTES } from '@/lib/http/httpRequest';
import { EXCHANGES } from '@/lib/types/generalTypes';
import {
    AllBalancesResponseItem,
    GetOpenPositionsByAccountIdPayload,
    GetShareOImagePayload,
    GetShareOImageResponse,
    SpotTrades,
    WALLET_HOLDING_PERIOD,
} from '@/state/balances/balancesTypes';
import { GeneralPosition } from '@/lib/websocket/websocketTypes';

export const getAllBalances = (): Promise<AxiosResponse<AllBalancesResponseItem[]>> =>
    httpRequest.get(API_ROUTES.BALANCES);

export const getAllOpenPositions = (): Promise<AxiosResponse<GeneralPosition[]>> =>
    httpRequest.get(API_ROUTES.OPEN_POSITIONS);

export const getOpenPositionsByAccountId = ({
    accountId,
}: GetOpenPositionsByAccountIdPayload): Promise<AxiosResponse<GeneralPosition[]>> =>
    httpRequest.get(`${API_ROUTES.OPEN_POSITIONS}/id/${accountId}`);

export const getBalanceByAccountId = ({ accountId }) =>
    httpRequest.get(`${API_ROUTES.BALANCES}/${accountId}`);

export const getPositionSharingImage = (
    payload: GetShareOImagePayload,
): Promise<AxiosResponse<GetShareOImageResponse>> =>
    httpRequest.put(`${API_ROUTES.CANVAS}`, payload);

export const getPositionsAnalytics = () =>
    httpRequest.get(`${API_ROUTES.OPEN_POSITIONS}/analytics`);

export const getWalletHoldings = (params: {
    exchange: EXCHANGES;
    apiKeyId: number;
    period: WALLET_HOLDING_PERIOD;
}) =>
    httpRequest.get(`${API_ROUTES.WALLET_HOLDINGS}/${params.exchange}/${params.apiKeyId}`, {
        params: { period: params.period },
    });

export const getSpotTrades = ({ exchange, accountId, ...params }: SpotTrades) =>
    httpRequest.get(`${API_ROUTES.SPOTS}/${exchange}/${accountId}`, { params });
